(() => {
  const CART_CHANNEL_NAME = 'vector-cart-sync';
  const STORAGE_KEY = 'vector-cart-updated';

  const broadcastChannel =
    'BroadcastChannel' in window
      ? new BroadcastChannel(CART_CHANNEL_NAME)
      : null;

  const localeRoot =
    window.Shopify?.routes?.root || '/';

  const cartUrl = `${localeRoot}cart.js`;

  const updateCartIndicators = async () => {
  try {
    const sectionUrl =
      `${window.location.pathname}?sections=cart-icon-bubble`;

    const sectionResponse = await fetch(sectionUrl, {
      headers: {
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      cache: 'no-store',
    });

    if (sectionResponse.ok) {
      const sections = await sectionResponse.json();
      const sectionHtml = sections['cart-icon-bubble'];

      if (sectionHtml) {
        const parsedHtml = new DOMParser().parseFromString(
          sectionHtml,
          'text/html'
        );

        const newCartIcon =
          parsedHtml.querySelector('#cart-icon-bubble');

        const currentCartIcon =
          document.querySelector('#cart-icon-bubble');

        if (newCartIcon && currentCartIcon) {
          currentCartIcon.innerHTML = newCartIcon.innerHTML;
        }
      }
    }

    const drawerItems =
      document.querySelector('cart-drawer-items');

    if (
      drawerItems &&
      typeof drawerItems.onCartUpdate === 'function'
    ) {
      drawerItems.onCartUpdate();
    }
  } catch (error) {
    console.warn('Vector cart synchronisation failed:', error);
  }
};

  const announceCartUpdate = () => {
    const message = {
      type: 'cart-updated',
      timestamp: Date.now(),
    };

    broadcastChannel?.postMessage(message);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(message));
    } catch (error) {
      // Storage may be unavailable.
    }

    window.setTimeout(updateCartIndicators, 500);
  };

  broadcastChannel?.addEventListener('message', (event) => {
    if (event.data?.type === 'cart-updated') {
      updateCartIndicators();
    }
  });

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY && event.newValue) {
      updateCartIndicators();
    }
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      updateCartIndicators();
    }
  });

  const initialiseStickyCart = (stickyCart) => {
    if (stickyCart.dataset.vectorStickyReady === 'true') return;

    const sectionId = stickyCart.dataset.sectionId;

    const originalSubmit = document.getElementById(
      `ProductSubmitButton-${sectionId}`
    );

    const originalQuantity = document.getElementById(
      `Quantity-${sectionId}`
    );

    const stickyQuantity = stickyCart.querySelector(
      '[data-vector-sticky-quantity]'
    );

    const stickySubmit = stickyCart.querySelector(
      '[data-vector-sticky-submit]'
    );

    const stickyMinus = stickyCart.querySelector(
      '[data-vector-sticky-minus]'
    );

    const stickyPlus = stickyCart.querySelector(
      '[data-vector-sticky-plus]'
    );

    if (
      !originalSubmit ||
      !stickyQuantity ||
      !stickySubmit ||
      !stickyMinus ||
      !stickyPlus
    ) {
      console.warn('Vector sticky cart could not initialise.');
      return;
    }

    stickyCart.dataset.vectorStickyReady = 'true';
    stickyCart.hidden = false;

    const normaliseQuantity = (value) => {
      const minimum = Number(stickyQuantity.min || 1);
      const maximum = stickyQuantity.max
        ? Number(stickyQuantity.max)
        : Infinity;
      const increment = Number(stickyQuantity.step || 1);

      let quantity = Number(value);

      if (!Number.isFinite(quantity)) quantity = minimum;

      quantity = Math.max(minimum, Math.min(maximum, quantity));

      const steps = Math.round((quantity - minimum) / increment);

      return minimum + steps * increment;
    };

    const setQuantity = (value) => {
      const quantity = normaliseQuantity(value);

      stickyQuantity.value = quantity;

      if (originalQuantity) {
        originalQuantity.value = quantity;
        originalQuantity.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      }
    };

    if (originalQuantity) {
      setQuantity(originalQuantity.value);

      originalQuantity.addEventListener('change', () => {
        stickyQuantity.value = originalQuantity.value;
      });
    }

    stickyQuantity.addEventListener('change', () => {
      setQuantity(stickyQuantity.value);
    });

    stickyMinus.addEventListener('click', () => {
      const increment = Number(stickyQuantity.step || 1);
      setQuantity(Number(stickyQuantity.value) - increment);
    });

    stickyPlus.addEventListener('click', () => {
      const increment = Number(stickyQuantity.step || 1);
      setQuantity(Number(stickyQuantity.value) + increment);
    });

    const syncButton = () => {
      stickySubmit.disabled = originalSubmit.disabled;

      const buttonText =
        originalSubmit.querySelector('span')?.textContent?.trim();

      if (buttonText) {
        stickySubmit.textContent = buttonText;
      }
    };

    syncButton();

    new MutationObserver(syncButton).observe(originalSubmit, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });

    stickySubmit.addEventListener('click', () => {
      setQuantity(stickyQuantity.value);

      stickySubmit.disabled = true;
      stickySubmit.setAttribute('aria-busy', 'true');

      originalSubmit.click();

      window.setTimeout(() => {
        syncButton();
        stickySubmit.removeAttribute('aria-busy');
        announceCartUpdate();
      }, 1200);
    });

    const updateVisibility = () => {
      const buttonPosition = originalSubmit.getBoundingClientRect();

      const shouldShow = buttonPosition.bottom < 0;

      stickyCart.classList.toggle('is-visible', shouldShow);

      document.body.classList.toggle(
        'vector-sticky-cart-visible',
        shouldShow
      );
    };

    updateVisibility();

    window.addEventListener('scroll', updateVisibility, {
      passive: true,
    });

    window.addEventListener('resize', updateVisibility, {
      passive: true,
    });

    const productForm = originalSubmit.closest('form');

    productForm?.addEventListener('submit', () => {
      window.setTimeout(announceCartUpdate, 1200);
    });
  };

  const initialiseAllStickyCarts = () => {
    document
      .querySelectorAll('[data-vector-sticky-cart]')
      .forEach(initialiseStickyCart);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseAllStickyCarts
    );
  } else {
    initialiseAllStickyCarts();
  }

  window.addEventListener('load', initialiseAllStickyCarts);
  document.addEventListener(
    'shopify:section:load',
    initialiseAllStickyCarts
  );
})();